(ns ui.view.survey.modals.confirm-submit
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.view.survey.modals.event :as event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn history-body
  [lang]
  [:div
   (loc/tr :you-are-about-to-submit-survey-row nil lang)])


(defn history-footer
  [survey-id lang]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::event/close-submit-modal]))}
     (loc/tr :cancel nil lang)]]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/primary-solid
     {:on-click (fn [_]
                  (rf/dispatch [::event/submit survey-id]))}
     (loc/tr :submit-survey-button nil lang)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])]
    [modal/view
     {:visible? @(rf/subscribe [::sub/submit-modal-open?])
      :hide!    #(rf/dispatch [::event/close-submit-modal])
      :size     :full}
     (loc/tr :survey-submit-modal-title nil lang)
     [history-body lang]
     [history-footer survey-id lang]]))
